import { OFFICER_COL_WIDE, OFFICER_TABLE_COLS } from './coverage-table-grid'
import { SITE_STATUS_META } from '../../../lib/lens'
import { dragText, type MandalOfficerRow } from '../../../lib/mandal-officers'

/** Two-letter avatar initials from an officer name. */
const initials = (name: string): string =>
  name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()

interface CoverageOfficerTableRowProps {
  row: MandalOfficerRow
}

/**
 * One worst-completion-first By-officer table row: avatar initials + name (with the `thin data` cue
 * for officers holding fewer than 3 sites) over the drag line ("2 never · 1 overdue"), the assigned
 * count, a completion bar in the surveyed green, and the completion %. Presentational, not a button —
 * officers have no drill from this view (parity with the previous dock).
 */
export function CoverageOfficerTableRow({ row }: CoverageOfficerTableRowProps) {
  const fill = SITE_STATUS_META.surveyed.color
  return (
    <div className={`${OFFICER_TABLE_COLS} rounded-[12px] border border-transparent px-3 py-[9px]`}>
      <span className="flex min-w-0 items-center gap-[11px]">
        <span className="grid h-[28px] w-[28px] flex-none place-items-center rounded-[9px] bg-gis-track-2 text-[11px] font-bold text-gis-ink-2">
          {initials(row.name)}
        </span>
        <span className="min-w-0">
          <span className="flex items-baseline gap-1.5">
            <span className="truncate text-[12.5px] font-semibold text-gis-ink">{row.name}</span>
            {row.thin && (
              <span className="flex-none text-[10.5px] font-semibold text-gis-muted">thin data</span>
            )}
          </span>
          <span className="mt-[2px] block truncate text-[10.5px] font-medium text-gis-soft">{dragText(row)}</span>
        </span>
      </span>

      <span className="text-right text-[12px] font-bold tabular-nums text-gis-ink-2">{row.assigned}</span>

      <span className={`${OFFICER_COL_WIDE} h-[7px] overflow-hidden rounded-full bg-gis-track-2`}>
        <span className="block h-full rounded-full" style={{ width: `${row.completionPct}%`, background: fill }} />
      </span>

      <span className="text-right text-[12px] font-bold tabular-nums text-gis-ink">{row.completionPct}%</span>
    </div>
  )
}
